<template>
	<div class="flex flex-col justify-center flex-auto w-full px-6 py-16 pb-24 mx-auto max-w-7xl sm:py-40 lg:px-8 font-utile">
		<h1 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">The requested page was not found</h1>
		<p class="max-w-3xl mt-6 text-base leading-7 text-gray-600">
			Oops! The page you're searching for has vanished into the digital wilderness. But fret not, there's plenty more to explore on our site. Use the menu or search to find your way back.</p>
		<div class="mt-10">
			<router-link :to="{ name: 'home' }" class="flex items-center text-lg font-semibold leading-7 text-hp-900 hover:text-hp-600">
				<span aria-hidden="true" class="mr-1.5"><HomeIcon class="w-4 h-4" /></span> Go to Home </router-link>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { HomeIcon } from '@heroicons/vue/20/solid'

export default defineComponent({
	components: {
		HomeIcon
	}
})
</script>
